import { IsOptional, IsString, MaxLength } from 'class-validator';
import { DEADLINE_TAKE_OVER_NOTE_MAX_LENGTH } from './deadline.constants';
import { IsIsoDay } from './is-iso-day.decorator';

export class TakeOverDeadlineDto {
  /** Giorno previsto del rinnovo. Il vincolo `oggi < until <= oggi + 90` lo applica il service sul calendario di Roma. */
  @IsIsoDay()
  until!: string;

  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_TAKE_OVER_NOTE_MAX_LENGTH)
  note?: string;
}
